export const FETCH_CONVERSATION = 'FETCH_CONVERSATION';
export const FETCH_CONVERSATION_REQUEST = 'FETCH_CONVERSATION_REQUEST';
export const FETCH_CONVERSATION_SUCCESS = 'FETCH_CONVERSATION_SUCCESS';
export const FETCH_CONVERSATION_FAILED = 'FETCH_CONVERSATION_FAILED';
export const SET_ACTIVE_PLATFORMS = 'SET_ACTIVE_PLATFORMS';
export const RESET_CONVERSATION = 'RESET_CONVERSATION'
export const SET_PAGE = 'SET_PAGE';
